import { PARAMS_ANIMAL,routes, routesPrefix } from './enums';


export const PATH_BUSCADOR_ANIMALES__ROOT = `${routesPrefix.root}`
export const PATH_BUSCADOR_ANIMALES__DETAIL_PERMALINK
    = `${routesPrefix.root}/${routes.animalPermalink}`;
export const PATH_BUSCADOR_ANIMALES__ESPECIE_RAZA_SEXO_EDAD_PAG
    = `${routesPrefix.root}/${PARAMS_ANIMAL.especie.name}${PARAMS_ANIMAL.especie.suffix}/${PARAMS_ANIMAL.raza.prefix}${PARAMS_ANIMAL.raza.name}/${PARAMS_ANIMAL.sexo.name}/${PARAMS_ANIMAL.edad.name}/${PARAMS_ANIMAL.pagina.name}`;

export const PATH_BUSCADOR_ANIMALES__ESPECIE_RAZA_SEXO_PAG
    = `${routesPrefix.root}/${PARAMS_ANIMAL.especie.name}${PARAMS_ANIMAL.especie.suffix}/${PARAMS_ANIMAL.raza.prefix}${PARAMS_ANIMAL.raza.name}/${PARAMS_ANIMAL.sexo.name}/${PARAMS_ANIMAL.pagina.name}`;

export const PATH_BUSCADOR_ANIMALES__ESPECIE_RAZA_PAG
    = `${routesPrefix.root}/${PARAMS_ANIMAL.especie.name}${PARAMS_ANIMAL.especie.suffix}/${PARAMS_ANIMAL.raza.prefix}${PARAMS_ANIMAL.raza.name}/${PARAMS_ANIMAL.pagina.name}`;

export const PATH_BUSCADOR_ANIMALES__ESPECIE_PAG
    = `${routesPrefix.root}/${PARAMS_ANIMAL.especie.name}${PARAMS_ANIMAL.especie.suffix}/${PARAMS_ANIMAL.pagina.name}`;

export const PATH_BUSCADOR_ANIMALES__ESPECIE_SEXO_EDAD_TAMANO_PAG
    = `${routesPrefix.root}/${PARAMS_ANIMAL.especie.name}${PARAMS_ANIMAL.especie.suffix}/${PARAMS_ANIMAL.sexo.name}/${PARAMS_ANIMAL.edad.name}/${PARAMS_ANIMAL.tamano.name}/${PARAMS_ANIMAL.pagina.name}`;
export const PATH_BUSCADOR_ANIMALES__ESPECIE_SEXO_EDAD_PAG
    = `${routesPrefix.root}/${PARAMS_ANIMAL.especie.name}${PARAMS_ANIMAL.especie.suffix}/${PARAMS_ANIMAL.sexo.name}/${PARAMS_ANIMAL.edad.name}/${PARAMS_ANIMAL.pagina.name}`;
export const PATH_BUSCADOR_ANIMALES__ESPECIE_SEXO_PAG
    = `${routesPrefix.root}/${PARAMS_ANIMAL.especie.name}${PARAMS_ANIMAL.especie.suffix}/${PARAMS_ANIMAL.sexo.name}/${PARAMS_ANIMAL.pagina.name}`;
